import { PartnerDetailService } from './../../services/partner-detail.service';
import { CommonService } from 'app/services/common.service';
import { CommonRouteFunctionService } from './../../services/common-routing-service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-secondary-nav',
  templateUrl: './secondary-nav.component.html',
  styleUrls: ['./secondary-nav.component.scss']
})
export class SecondaryNavComponent implements OnInit, OnDestroy {
  partners: any[];
  selectedPartner: number;
  routerData: string;
  userRole: string;
  loggedInPartnerId: number;
  visible: boolean;
  routerSub: Subscription;
  routeArray: any[];
  roleVisible: boolean;
  userModule: string;

  constructor(
    private _commonAuthService: CommonAuthenticationService,
    private commonRouteFunctionService: CommonRouteFunctionService,
    private router: Router,
    private routes: ActivatedRoute, private _commonService: CommonService,
    private _partnerDetailService: PartnerDetailService) { }

  ngOnInit() {
    this.getPartnerList();
    this.breadcrumbs();
    this.userRole = this._commonAuthService.getRoleName().toLowerCase();
    this.userModule = this._commonAuthService.getModule().toLowerCase();
    const localRouteArray = localStorage.getItem('routeArray');
    const localModule = JSON.parse(localStorage.getItem('loginUserData')).module;
    if (localRouteArray) {
      this.routeArray = JSON.parse(localStorage.getItem('routeArray'));
    }
    if (!localRouteArray && this.userRole === 'student') {
      this.routeArray = ['student', 'home'];
    } else if (!localRouteArray && localModule === 'Coach') {
      this.routeArray = ['coach', 'home'];
    }
    this.loggedInPartnerId = JSON.parse(localStorage.getItem('loginUserData')).partnerId;
    this.selectedPartner = this.loggedInPartnerId;
    this.getPartner(false);
  }

  /**
   *@ngdoc method
   *@name getPartnerList
   *@methodOf secondary-nav.component
   *@description
   * - This is a method, which is used to get partner list
   @param {string} selected list item
  */
  // TODO: Transition this method to _partnerDetailService (service implementation)
  getPartnerList() {
    this._partnerDetailService.getPartnerList()
      .subscribe(
        (partners: any) => {
          this.partners = partners.items;
        },
        (error) => {
          console.error(error);
        }
      );
  }

  /**
   *@ngdoc method
   *@name getPartner
   *@methodOf secondary-nav.component
   *@description
   * - This is a method, which is used to get selected partner
   @param {string} selected list item
  */

  getPartner(flag) {
    this._partnerDetailService.switchSelectedPartner(this.selectedPartner);
  }

  /**
   *@ngdoc method
   *@name isActive
   *@methodOf secondary-nav.component
   *@description
   * - This is a method, which is used to make selected list item as active
   @param {string} selected list item
   @returns {boolean} return boolean
  */
  breadcrumbs() {
    this.router.events.subscribe(event => {
      if (event.constructor.name === 'NavigationStart') {
        const currentPageData = JSON.parse(localStorage.getItem('currentPageData'))
        const breadCrumbRoute = event['url'].split('/');
        if (breadCrumbRoute[0] === '') {
          breadCrumbRoute.splice(0, 1);
        }
        if (currentPageData && currentPageData.path === 'bulkMessageHub') {
          this.routeArray.push(breadCrumbRoute[2]);
        } else {
          if (this.routeArray && this.routeArray.indexOf(breadCrumbRoute[1]) === -1) {
            this.routeArray.push(breadCrumbRoute[1]);
          }
        }
        if (this.routeArray && this.routeArray[2] === undefined) {
          this.routeArray.splice(2, 1);
        }
        localStorage.setItem('routeArray', JSON.stringify(this.routeArray));
      }
    });
    this.routerSub = this.commonRouteFunctionService.breadCrumb.subscribe((data: string) => {
      this.routeArray = data.split('/');
      if (this.routeArray[0] === 'admin' && this.userRole === 'super coach') {
        this.routeArray[0] = 'coach'
      }
      if (this.routeArray[0] === '') {
        this.routeArray.splice(0, 1);
      }
      this.routerData = data.split('/')[1];
      localStorage.setItem('routeArray', JSON.stringify(this.routeArray));
      const routesCheck = ['referenceListTypes', 'referenceListValues', 'mapping', 'users', 'collegeData', 'contentEditor', 'brickManager', 'mappedContentList', 'contentMapper', 'heatMap', 'operatingHours', 'displayMessage', 'configureHeatMap', 'home', 'glossary'];
      this.visible = this.routerData ? routesCheck.includes(this.routerData) : true;
      this.roleVisible = ['super coach'].includes(this.userRole.toLowerCase()) || ['admin'].includes(this.userModule.toLowerCase()) || (this.routerData === 'heatMap' && this.userRole.toLowerCase() !== 'student');
      this._commonService.setDataWithoutObservable(data, 'breadCrumbData');
    });
  }
  isActive(item) {
    return this.selectedPartner === item;
  }
  getRouteParam() {
    const routeUrl = this.router.url;
    this.routeArray = routeUrl.split('/');
    this.routeArray.shift();
  }

  onBreadCrumb(route) {
    let tempArray = [];
    tempArray = this.getRoute(route);
    localStorage.setItem('routeArray', JSON.stringify(tempArray))
    if (tempArray.length > 2) {
      const firstRoute = tempArray.shift();
      const secondRoute = tempArray.pop();
      tempArray = [firstRoute, secondRoute];
    } else if (tempArray.length === 1) {
      tempArray.push('home');
      this.routeArray.push('home')
    }
    if (this.userRole === 'super coach' && tempArray[1] === 'mappedContentList') {
      tempArray[0] = 'admin'
    }
    this.router.navigate(['../' + tempArray.join('/')], { relativeTo: this.routes });
    this._commonService.setDataWithoutObservable(this.routeArray.join('/'), 'breadCrumbData');
  }


  getRoute(route) {
    const routeArray = [];
    for (let i = 0; i < this.routeArray.length; i++) {
      if (this.routeArray[i] === route) {
        routeArray.push(this.routeArray[i]);
        this.routeArray = JSON.parse(JSON.stringify(routeArray));
        return routeArray;
      } else {
        routeArray.push(this.routeArray[i])
      }
    }
  }
  ngOnDestroy() {
    this.routerSub.unsubscribe();
  }
}
